/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { api } from "api";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import Select from "react-select";
import i18n from "i18next";
import RolePlayDetail from "./RolePlayDetail";

class RolePlayDetails extends Component {
  state = {
    rolePlays: [],
    isManager: localStorage.getItem("roles").includes("Manager"),
    selectedDepartment: null,
    selectedEmployee: null,
    employeeOptions: [],
    employees: [],
  };

  settings = {
    itemsPerPage: 10,
  };

  deparmentOptions = [
    { value: "50020", label: i18n.t("10049") },
    { value: "50021", label: i18n.t("10050") },
    { value: "50022", label: i18n.t("10047") },
    { value: "50023", label: i18n.t("10048") },
  ];

  componentDidMount() {
    if (localStorage.getItem("roles").includes("Manager")) this.getEmployees();

    if (!localStorage.getItem("roles").includes("Manager"))
      this.getRolePlayDetails();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.employees !== this.state.employees) {
      const currentEmployee = this.state.employees.find(
        (z) => z.id === this.props.profile.general.id
      );

      if (!currentEmployee) return;

      const currentEmployeeDepartment = this.deparmentOptions.find(
        (o) => o.value === String(currentEmployee.serviceType.value)
      );

      this.setState({
        selectedDepartment: currentEmployeeDepartment.value,
        selectedEmployee: currentEmployee.id,
      });

      this.getRolePlayDetails(currentEmployee.id);
    }

    if (prevState.selectedDepartment !== this.state.selectedDepartment) {
      const employeesOfDepartment = this.state.employees.filter(
        (z) => z.serviceType.value === parseInt(this.state.selectedDepartment)
      );
      const _employeeOptions = employeesOfDepartment.map((e) => ({
        value: e.id,
        label: e.fullname,
      }));
      this.setState({
        employeeOptions: _employeeOptions,
      });
    }

    if (prevState.selectedEmployee !== this.state.selectedEmployee) {
      this.getRolePlayDetails(this.state.selectedEmployee);
    }
  }

  getEmployees = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-360/employees`)
      .then((response) => {
        this.setState({
          employees: response.data.data.employees,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  getRolePlayDetails = (employeeId) => {
    this.props.onProcessBegin();
    let query = "";
    if (this.state.isManager)
      query = `/api/employee-360/role-play-details/${employeeId}`;
    else query = "/api/employee-360/role-play-details";
    api
      .get(query)
      .then((response) => {
        this.setState({
          rolePlays: response.data.data.employeeRolePlays
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  handleDepartmentSelect = (e) => {
    this.setState({ selectedDepartment: e.value, selectedEmployee: null });
  };

  renderDepartmentCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        options={this.deparmentOptions}
        onChange={(e) => this.handleDepartmentSelect(e)}
        value={this.deparmentOptions.find(
          (o) => o.value === String(this.state.selectedDepartment)
        )}
      />
    );
  };

  handleEmployeeSelect = (e) => {
    this.setState({ selectedEmployee: e.value });
  };

  renderEmployeesCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        label="ee"
        options={this.state.employeeOptions}
        onChange={(e) => this.handleEmployeeSelect(e)}
        value={
          this.state.selectedEmployee
            ? this.state.employeeOptions.find(
              (o) => o.value === this.state.selectedEmployee
            )
            : null
        }
      />
    );
  };

  renderPosition = () => {
    if (
      this.state.selectedEmployee === null ||
      this.state.selectedEmployee === ""
    )
      return null;
    const employee = this.state.employees.find(
      (z) => z.id === this.state.selectedEmployee
    );
    return <span>{employee.position.name}</span>;
  };

  renderFilterBar = () => {
    if (!this.state.isManager) return null;

    return (
      <div className="row calculateArea">
        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
          <div className="ml-2">
            <label htmlFor="departmanSeciniz" className='filterHeader'>
              <Trans desc="Departman Seçiniz">10138</Trans>:
            </label>
            {this.renderDepartmentCombo()}
          </div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
          <div className="ml-2">
            <label htmlFor="seciliPersonel" className='filterHeader'>
              <Trans desc="Seçili Personel">10139</Trans>:
            </label>
            {this.renderEmployeesCombo()}
          </div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
          <div>
            <label htmlFor="seciliPersonel" className="pl-2">
              <Trans desc="Pozisyon">10140</Trans>:
            </label>
            <p id="seciliPersonel" className="mb-0 pl-2 positionName">
              {this.renderPosition()}
            </p>
          </div>
        </div>
      </div>
    );
  };

  renderRolePlays = () => {
    return (
      <tbody>
        {!this.state.rolePlays || this.state.rolePlays.length == 0 ?
          <tr>
            <td colSpan={7} className="text-center">
              <Trans Desc="Kayıt bulunamadı.">10732</Trans>
            </td>
          </tr>
          : this.state.rolePlays.map((rp, idx) => {
            return (<RolePlayDetail rp={rp} idx={idx} key={idx} userId={this.props.profile.general.id} selectedEmployeeId={this.state.selectedEmployee} />);
          })}
      </tbody>
    );
  };

  render() {
    return (
      <>
        {this.renderFilterBar()}
        <div className="row pb-3">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <table className="table display dtRolePlay responsive dataTable no-footer dtr-none collapsed">
              <thead>
                <tr>
                  <th className="all">
                    <div className="tableTitle">
                      <Trans desc="Eğitim Oturumu">10726</Trans>
                    </div>
                  </th>
                  <DesktopBreakpoint>
                    <th className="all">
                      <div className="tableTitle">
                        <Trans desc="Soru">10730</Trans>
                      </div>
                    </th>
                    <th className="all">
                      <div className="tableTitle">
                        <Trans desc="Cevap">10731</Trans>
                      </div>
                    </th>
                    <th className="all">
                      <div className="tableTitle">
                        <Trans desc="Durum">10727</Trans>
                      </div>
                    </th>
                    <th className="all">
                      <div className="tableTitle">
                        <Trans desc="Araç">10728</Trans>
                      </div>
                    </th>
                    <th className="all">
                      <div className="tableTitle">
                        <Trans desc="Tarih">10729</Trans>
                      </div>
                    </th>
                  </DesktopBreakpoint>
                  <th className="all"></th>
                </tr>
              </thead>
              {this.renderRolePlays()}
            </table>
          </div>
        </div>
      </>)
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.profile,
  };
};

export default connect(
  mapStateToProps,
  {}
)(requireAuth(containsLongRunningProcess(RolePlayDetails)));
